<template>
  <div class="vx-col w-full mb-base">
    <vx-card title="Multiple Columns">
      <ValidationObserver v-slot="{ invalid }">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <ValidationProvider :name="$t('demo.first-name')" rules="required|min:4" v-slot="{ errors }">
              <vs-input :label-placeholder="$t('demo.first-name')" class="w-full" v-model="form.firstName"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <ValidationProvider :name="$t('demo.last-name')" rules="required|min:4" v-slot="{ errors }">
              <vs-input :label-placeholder="$t('demo.last-name')" class="w-full" v-model="form.lastName"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <ValidationProvider :name="$t('demo.city')" rules="required" v-slot="{ errors }">
              <vs-input :label-placeholder="$t('demo.city')" class="w-full" v-model="form.city"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <ValidationProvider :name="$t('demo.country')" rules="required" v-slot="{ errors }">
              <vs-input :label-placeholder="$t('demo.country')" class="w-full" v-model="form.country"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <ValidationProvider :name="$t('demo.company')" rules="required" v-slot="{ errors }">
              <vs-input class="w-full" label-placeholder="Company" v-model="form.company"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <ValidationProvider :name="$t('demo.email')" rules="required|email" v-slot="{ errors }">
              <vs-input :label-placeholder="$t('demo.email')" class="w-full" type="email" v-model="form.email"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-6">
            <vs-checkbox class="inline-flex" v-model="form.rememberMe">{{$t('demo.remember-me')}}</vs-checkbox>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button :disabled="processing || invalid" class="mr-3 mb-2">{{$t('demo.submit')}}</vs-button>
            <vs-button class="mb-2" color="warning" type="border">{{$t('demo.reset')}}
            </vs-button>
          </div>
        </div>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
  import {createHelpers} from 'vuex-map-fields';

  import store from '@/store';
  import user from '@/store/modules/user';

  if (!store.state.user) store.registerModule(`user`, user);

  const {mapFields: mapUserFields} = createHelpers({
    getterType: `user/getField`,
    mutationType: `user/updateField`,
  });

  export default {
    name: "FormValidate",
    data() {
      return {
        form: {
          firstName: '',
          lastName: '',
          city: '',
          country: '',
          company: '',
          email: '',
          rememberMe: false,
        }
      }
    },
    computed: {
      ...mapUserFields(["processing"])
    },
  }
</script>

<style scoped>

</style>
